import { H1 } from '@atoms/Typographies';
import { useOpenRequest } from '@hooks/Services';
import { Container, ContainerForFacility } from '@organisms/GenesisEs/Layouts';
import { DetailApplicationInfo, DetailMemoList, DetailTransmissionResult } from '@organisms/GenesisEs/List';
import Head from '@organisms/Heads/Head';
import { Page404 } from '@pages/index';
import CommonTemplate from '@templates/Common';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';


const Detail = () => {
    const id: any = useParams().id;
    const listData = useOpenRequest.useAllListData(id);
    const { data } = listData;
    if (!data) {
        return <Page404 />
    }
    const number = data.powerCustomerLocationNumber;

    return (
        <CommonTemplate>
            <Head title="再点申込結果詳細" />
            <HeadingWithStyled className="mb-4">
                <H1>再点申込結果詳細</H1>
            </HeadingWithStyled>

            <Container
                title='申込情報'
                children={<DetailApplicationInfo listData={listData} />}
            />
            <Container
                title='送信結果'
                children={<DetailTransmissionResult />}
            />
            <ContainerForFacility
                powerCustomerLocationNumber={number}
            />
            <Container
                title='MEMO'
                children={<DetailMemoList />}
            />

        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`

export default Detail;
